angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "OFFER_ACCEPT_MODAL": {
    "MESSAGE_MIN_LENGTH" : "Your message is too short. Please be more specific.",
    "REQUIRED" : "This field is required",
  },
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/conversations/trip_offer_accept_modal/trip_offer_accept_modal.json
// module id = 427
// module chunks = 24